// The moderator-only "Area directory" link in the People panel. Off since
// Oct 8 2026: Glenn tripped on a directory entry in Assign and asked to be
// rid of it, and his own People lists now do that job. The directory screen
// (AreaPeopleView), its store and its rules are all still in place, so
// setting this true brings the link back.
export const AREA_DIRECTORY_LINK_ENABLED = false;
